import Cookies from 'js-cookie'
// cookie保存的天数
import config from '@/config'
// import { forEach, hasOneOf, objEqual } from '@/libs/tools'
import { forEach, hasOneOf } from '@/libs/tools'
const { title, cookieExpires, useI18n } = config

export const TOKEN_KEY = 'token'

export const setToken = (token) => {
  Cookies.set(TOKEN_KEY, token, { expires: cookieExpires || 1 })
}

export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY)
  if (token) return token
  else return false
}

export const hasChild = (item) => {
  return item.children && item.children.length !== 0
}

const showThisMenuEle = (item, access) => {
  if (item.meta && item.meta.access && item.meta.access.length) {
    if (hasOneOf(item.meta.access, access)) return true
    else return false
  } else return true
}
/**
 * @param {Array} list 通过路由列表得到菜单列表
 * @param {access} 权限
 * @returns {Array}
 */
export const getMenuByRouter = (list, access) => {
  let res = []
  if (!list) {
    return
  }
  forEach(list, item => {
    if (!item.meta || (item.meta && !item.meta.hideInMenu)) {
      let obj = {
        icon: (item.meta && item.meta.icon) || '',
        name: item.name,
        meta: item.meta
      }
      if ((hasChild(item) || (item.meta && item.meta.showAlways)) && showThisMenuEle(item, access)) {
        obj.children = getMenuByRouter(item.children, access)
      }
      if (item.meta && item.meta.href) obj.href = item.meta.href
      if (showThisMenuEle(item, access)) res.push(obj)
    }
  })
  return res
}

/**
 * @param {Array} routeMetched 当前路由metched
 * @returns {Array}
 */
export const getBreadCrumbList = (route, homeRoute) => {
  let homeItem = { ...homeRoute, icon: homeRoute.meta.icon }
  let routeMetched = route.matched
  if (routeMetched.some(item => item.name === homeRoute.name)) return [homeItem]
  let res = routeMetched.filter(item => {
    return item.meta === undefined || !item.meta.hideInBread
  }).map(item => {
    let meta = { ...item.meta }
    if (meta.title && typeof meta.title === 'function') {
      meta.__titleIsFunction__ = true
      meta.title = meta.title(route)
    }
    let obj = {
      icon: (item.meta && item.meta.icon) || '',
      name: item.name,
      meta: meta
    }
    return obj
  })
  res = res.filter(item => {
    return !item.meta.hideInMenu
  })
  return [{ ...homeItem, to: homeRoute.path }, ...res]
}

export const getRouteTitleHandled = (route) => {
  let router = { ...route }
  let meta = { ...route.meta }
  let title = ''
  if (meta.title) {
    if (typeof meta.title === 'function') {
      meta.__titleIsFunction__ = true
      title = meta.title(router)
    } else title = meta.title
  }
  meta.title = title
  router.meta = meta
  return router
}

export const showTitle = (item, vm) => {
  let { title, __titleIsFunction__ } = item.meta
  if (!title) return
  if (useI18n) {
    if (title.includes('{{') && title.includes('}}') && useI18n) title = title.replace(/({{[\s\S]+?}})/, (m, str) => str.replace(/{{([\s\S]*)}}/, (m, _) => vm.$t(_.trim())))
    else if (__titleIsFunction__) title = item.meta.title
    else title = vm.$t(item.name)
  } else title = (item.meta && item.meta.title) || item.name
  return title
}

/**
 * @description 本地存储和获取标签导航列表
 */
export const setTagNavListInLocalstorage = list => {
  localStorage.tagNaveList = JSON.stringify(list)
}
/**
 * @returns {Array} 其中的每个元素只包含路由原信息中的name, path, meta三项
 */
export const getTagNavListFromLocalstorage = () => {
  const list = localStorage.tagNaveList
  return list ? JSON.parse(list) : []
}

/**
 * @param {Array} routers 路由列表数组
 * @description 用于找到路由列表中name为home的对象
 */
export const getHomeRoute = (routers, homeName = 'home') => {
  let i = -1
  let len = routers.length
  let homeRoute = {}
  while (++i < len) {
    let item = routers[i]
    if (item.children && item.children.length) {
      let res = getHomeRoute(item.children, homeName)
      if (res.name) return res
    } else {
      if (item.name === homeName) homeRoute = item
    }
  }
  return homeRoute
}

/**
 * @param {*} list 现有标签导航列表
 * @param {*} newRoute 新添加的路由原信息对象
 * @description 如果该newRoute已经存在则不再添加
 */
export const getNewTagList = (list, newRoute) => {
  const { name, path, meta } = newRoute
  let newList = [...list]
  if (newList.findIndex(item => item.name === name) >= 0) return newList
  else newList.push({ name, path, meta })
  return newList
}

/**
 * @param {*} access 用户权限数组，如 ['super_admin', 'admin']
 * @param {*} route 路由列表
 */
const hasAccess = (access, route) => {
  if (route.meta && route.meta.access) return hasOneOf(access, route.meta.access)
  else return true
}

/**
 * 权鉴
 * @param {*} name 即将跳转的路由name
 * @param {*} access 用户权限数组
 * @param {*} routes 路由列表
 * @description 用户是否可跳转到该页
 */
export const canTurnTo = (name, access, routes) => {
  const routePermissionJudge = (list) => {
    return list.some(item => {
      if (item.children && item.children.length) {
        return routePermissionJudge(item.children)
      } else if (item.name === name) {
        return hasAccess(access, item)
      }
    })
  }

  return routePermissionJudge(routes)
}

/**
 * @param {*} access 用户权限数组，如 ['super_admin', 'admin']
 * @param {*} weights 权重
 * @param {*} route 路由列表
 */
const hasWeightsAccess = (access, weights, route) => {
  if (route.meta && route.meta.access) {
    if (route.weights >= weights) {
      return hasOneOf(access, route.meta.access)
    } else {
      return false
    }
  }
  return true
}

/**
 * 权鉴
 * @param {*} name 即将跳转的路由name
 * @param {*} access 用户权限数组
 * @param {*} weights 权重
 * @param {*} routes 路由列表
 * @description 用户是否可跳转到该页
 */
export const canWeightsTurnTo = (name, access, weights, routes) => {
  const routePermissionJudge = (list) => {
    return list.some(item => {
      if (item.children && item.children.length) {
        return routePermissionJudge(item.children)
      } else if (item.name === name) {
        return hasWeightsAccess(access, weights, item)
      }
    })
  }

  return routePermissionJudge(routes)
}

/**
 * @param {String} url
 * @description 从URL中解析参数
 */
export const getParams = url => {
  let keyValueArr = null
  if (url.indexOf('?') >= 0) {
    keyValueArr = url.split('?')[1].split('&')
  } else {
    keyValueArr = url.split('&')
  }

  let paramObj = {}
  keyValueArr.forEach(item => {
    const keyValue = item.split('=')
    paramObj[keyValue[0]] = keyValue[1]
  })
  return paramObj
}

/**
 * @param {Array} list 标签列表
 * @param {String} name 当前关闭的标签的name
 */
export const getNextRoute = (list, route) => {
  let res = {}
  if (list.length === 2) {
    res = getHomeRoute(list)
  } else {
    const index = list.findIndex(item => routeEqual(item, route))
    if (index === list.length - 1) res = list[list.length - 2]
    else res = list[index + 1]
  }
  return res
}

/**
 * @param {Number} times 回调函数需要执行的次数
 * @param {Function} callback 回调函数
 */
export const doCustomTimes = (times, callback) => {
  let i = -1
  while (++i < times) {
    callback(i)
  }
}

/**
 * @param {Object} file 从上传组件得到的文件对象
 * @returns {Promise} resolve参数是解析后的二维数组
 * @description 从Csv文件中解析出表格，解析成二维数组
 */
export const getArrayFromFile = (file) => {
  let nameSplit = file.name.split('.')
  let format = nameSplit[nameSplit.length - 1]
  return new Promise((resolve, reject) => {
    let reader = new FileReader()
    reader.readAsText(file) // 以文本格式读取
    let arr = []
    reader.onload = function (evt) {
      let data = evt.target.result // 读到的数据
      let pasteData = data.trim()
      arr = pasteData.split((/[\n\u0085\u2028\u2029]|\r\n?/g)).map(row => {
        return row.split('\t')
      }).map(item => {
        return item[0].split(',')
      })
      if (format === 'csv') resolve(arr)
      else reject(new Error('[Format Error]:你上传的不是Csv文件'))
    }
  })
}

/**
 * @param {Array} array 表格数据二维数组
 * @returns {Object} { columns, tableData }
 * @description 从二维数组中获取表头和表格数据，将第一行作为表头，用于在iView的表格中展示数据
 */
export const getTableDataFromArray = (array) => {
  let columns = []
  let tableData = []
  if (array.length > 1) {
    let titles = array.shift()
    columns = titles.map(item => {
      return {
        title: item,
        key: item
      }
    })
    tableData = array.map(item => {
      let res = {}
      item.forEach((col, i) => {
        res[titles[i]] = col
      })
      return res
    })
  }
  return {
    columns,
    tableData
  }
}

export const findNodeUpper = (ele, tag) => {
  if (ele.parentNode) {
    if (ele.parentNode.tagName === tag.toUpperCase()) {
      return ele.parentNode
    } else {
      return findNodeUpper(ele.parentNode, tag)
    }
  }
}

export const findNodeUpperByClasses = (ele, classes) => {
  let parentNode = ele.parentNode
  if (parentNode) {
    let classList = parentNode.classList
    if (classList && classes.every(className => classList.contains(className))) {
      return parentNode
    } else {
      return findNodeUpperByClasses(parentNode, classes)
    }
  }
}

export const findNodeDownward = (ele, tag) => {
  const tagName = tag.toUpperCase()
  if (ele.childNodes.length) {
    let i = -1
    let len = ele.childNodes.length
    while (++i < len) {
      let child = ele.childNodes[i]
      if (child.tagName === tagName) return child
      else return findNodeDownward(child, tag)
    }
  }
}

export const showByAccess = (access, canViewAccess) => {
  return hasOneOf(canViewAccess, access)
}

/**
 * @description 根据name/params/query判断两个路由对象是否相等
 * @param {*} route1 路由对象
 * @param {*} route2 路由对象
 */
export const routeEqual = (route1, route2) => {
  // const params1 = route1.params || {}
  // const params2 = route2.params || {}
  // const query1 = route1.query || {}
  // const query2 = route2.query || {}
  // return (route1.name === route2.name) && objEqual(params1, params2) && objEqual(query1, query2)
  return (route1.name === route2.name)
}

/**
 * 判断打开的标签列表里是否已存在这个新添加的路由对象
 */
export const routeHasExist = (tagNavList, routeItem) => {
  let len = tagNavList.length
  let res = false
  doCustomTimes(len, (index) => {
    if (routeEqual(tagNavList[index], routeItem)) res = true
  })
  return res
}

/**
 * 保存localStorage
 */
export const localSave = (key, value) => {
  localStorage.setItem(key, value)
}

/**
 * 读取localStorage
 */
export const localRead = (key) => {
  return localStorage.getItem(key)
}

/**
 * 移除localStorage
 */
export const localRemove = (key) => {
  return localStorage.removeItem(key)
}

// scrollTop animation
export const scrollTop = (el, from = 0, to, duration = 500, endCallback) => {
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = (
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (callback) {
        return window.setTimeout(callback, 1000 / 60)
      }
    )
  }
  const difference = Math.abs(from - to)
  const step = Math.ceil(difference / duration * 50)

  const scroll = (start, end, step) => {
    if (start === end) {
      endCallback && endCallback()
      return
    }

    let d = (start + step > end) ? end : start + step
    if (start > end) {
      d = (start - step < end) ? end : start - step
    }

    if (el === window) {
      window.scrollTo(d, d)
    } else {
      el.scrollTop = d
    }
    window.requestAnimationFrame(() => scroll(d, end, step))
  }
  scroll(from, to, step)
}

/**
 * @description 根据当前跳转的路由设置显示在浏览器标签的title
 * @param {Object} routeItem 路由对象
 * @param {Object} vm Vue实例
 */
export const setTitle = (routeItem, vm) => {
  const handledRoute = getRouteTitleHandled(routeItem)
  const pageTitle = showTitle(handledRoute, vm)
  const resTitle = pageTitle ? `${title} - ${pageTitle}` : title
  window.document.title = resTitle
}

/**
 * @description 格式化日期
 * @param {date} 日期
 * @param {fmt} 格式
 */
export const formatDate = (date, fmt) => {
  if (date === null || date === undefined) {
    return ''
  }

  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'S': date.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

/**
 * @description 返回静态服务器地址
 * @param {fileUrl} 相对地址
 */
export const getFileUrl = (fileUrl) => {
  if (fileUrl === null || fileUrl === undefined) {
    return ''
  } else if (fileUrl.indexOf('/') !== 0) {
    fileUrl = '/' + fileUrl
  }

  return config.staticServer + fileUrl
}

/**
 * @description 返回默认头像
 */
export const getDefaultAvatar = () => {
  return config.defaultAvatar
}

/**
 * @param params 需要格式化的参数, 主要去掉null和格式化时间
 * @description 返回 URLSearchParams
 */
export const formatParams = (params) => {
  let postParams = new URLSearchParams()

  if (params != null) {
    for (let key in params) {
      if (params[key] != null) {
        if (params[key] instanceof Date) {
          postParams.append(key, formatDate(params[key], 'yyyy-MM-dd hh:mm:ss'))
        } else {
          postParams.append(key, params[key])
        }
      }
    }
  }

  return postParams
}

/**
 * @param params 需要格式化的参数, 主要去掉null和格式化时间
 * @description 返回 URLSearchParams
 */
export const formatVOParams = (params) => {
  let postParams = new URLSearchParams()

  if (params != null) {
    for (let key in params) {
      if (params[key] != null) {
        if (params[key] instanceof Date) {
          postParams.append(key, formatDate(params[key], 'yyyy-MM-dd hh:mm:ss'))
        } else if (params[key] instanceof Object) {
          for (let itemKey in params[key]) {
            if (params[key][itemKey] != null) {
              if (params[key][itemKey] instanceof Date) {
                postParams.append(key + '.' + itemKey, formatDate(params[key][itemKey], 'yyyy-MM-dd hh:mm:ss'))
              } else {
                postParams.append(key + '.' + itemKey, params[key][itemKey])
              }
            }
          }
        } else {
          postParams.append(key, params[key])
        }
      }
    }
  }

  return postParams
}

/**
 * @param params 需要格式化的参数, 主要去掉null和格式化时间,并且格式化查询条件
 * @description 返回 URLSearchParams
 */
export const fmtSearchParams = (params) => {
  let postParams = new URLSearchParams()

  if (params != null) {
    // 查询条件
    let searchParams = params['searchParams']
    if (searchParams) {
      for (let searchKey in searchParams) {
        if (searchParams[searchKey]) {
          if (searchParams[searchKey] instanceof Date) {
            postParams.append(searchKey, formatDate(searchParams[searchKey], 'yyyy-MM-dd hh:mm:ss'))
          } else {
            postParams.append(searchKey, searchParams[searchKey])
          }
        }
      }
    }
    params['searchParams'] = null

    // 分页条件
    let pageContentParams = params['pageContent']
    if (pageContentParams) {
      let pageSize = pageContentParams['pageSize']
      let pageNumber = pageContentParams['pageNumber']
      let sortKey = pageContentParams['sortKey']
      let sortOrder = pageContentParams['sortOrder']
      let defaultSortKey = pageContentParams['defaultSortKey']
      let defaultSortOrder = pageContentParams['defaultSortOrder']
      postParams.append('pageSize', pageSize || 10)
      postParams.append('pageNumber', pageNumber || 0)
      postParams.append('sortKey', sortKey || '')
      postParams.append('sortOrder', sortOrder || '')
      postParams.append('defaultSortKey', defaultSortKey || '')
      postParams.append('defaultSortOrder', defaultSortOrder || '')
    }
    params['pageContent'] = null

    // 其他条件
    for (let key in params) {
      if (params[key] != null) {
        if (params[key] instanceof Date) {
          postParams.append(key, formatDate(params[key], 'yyyy-MM-dd hh:mm:ss'))
        } else {
          postParams.append(key, params[key])
        }
      }
    }
  }

  return postParams
}

/*
* 格式化数字显示方式
* 用法
* formatNumber(12345.999,'#,##0.00');
* formatNumber(12345.999,'#,##0.##');
* formatNumber(123,'000000');
* @param num
* @param pattern
*/
export const formatNumber = (num, pattern) => {
  let fmtarr = pattern ? pattern.split('.') : ['']

  // 四舍五入处理
  let decimals = (fmtarr.length > 1 ? fmtarr[1].length : 0)

  num = Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals)

  // 值->字符串->数组
  let strarr = num ? num.toString().split('.') : ['0']
  let retstr = ''

  // 整数部分
  let str = strarr[0]
  let fmt = fmtarr[0]
  let i = str.length - 1
  let comma = false
  for (let f = fmt.length - 1; f >= 0; f--) {
    switch (fmt.substr(f, 1)) {
      case '#':
        if (i >= 0) {
          retstr = str.substr(i--, 1) + retstr
        }
        break
      case '0':
        if (i >= 0) {
          retstr = str.substr(i--, 1) + retstr
        } else {
          retstr = '0' + retstr
        }
        break
      case ',':
        comma = true
        retstr = ',' + retstr
        break
    }
  }
  // 整数字符串替换格式后剩余字符串处理
  if (i >= 0) {
    if (comma) {
      let l = str.length
      for (; i >= 0; i--) {
        retstr = str.substr(i, 1) + retstr
        if (i > 0 && ((l - i) % 3) === 0) {
          retstr = ',' + retstr
        }
      }
    } else {
      retstr = str.substr(0, i + 1) + retstr
    }
  }

  retstr = retstr + '.'

  // 处理小数部分
  str = strarr.length > 1 ? strarr[1] : ''
  fmt = fmtarr.length > 1 ? fmtarr[1] : ''
  i = 0
  for (let f = 0; f < fmt.length; f++) {
    switch (fmt.substr(f, 1)) {
      case '#':
        if (i < str.length) {
          retstr += str.substr(i++, 1)
        }
        break
      case '0':
        if (i < str.length) {
          retstr += str.substr(i++, 1)
        } else {
          retstr += '0'
        }
        break
    }
  }

  // 返回
  // 1.去掉开头的逗号（，）和加号（+）；2.结尾的小数点（.)
  return retstr.replace(/^,+/, '').replace(/\.$/, '')
}

/*
* 检查身份证是否合法.
* @param idcode
*/
export const checkIdCard = (idcode) => {
  // 加权因子
  let weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]

  // 校验码
  let check_code = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']

  let code = idcode + ''
  // 最后一位
  let last = idcode[17]

  let seventeen = code.substring(0, 17)

  // ISO 7064:1983.MOD 11-2
  // 判断最后一位校验码是否正确
  let arr = seventeen.split('')
  // let len = arr.length
  let num = 0
  // for(var i = 0; i < len; i++){
  //     num = num + arr[i] * weight_factor[i]
  // }
  arr.forEach((item, index) => {
    num += item * weight_factor[index]
  })

  // 获取余数
  let resisue = num % 11
  let last_no = check_code[resisue]

  // 格式的正则
  // 正则思路
  /*
  第一位不可能是0
  第二位到第六位可以是0-9
  第七位到第十位是年份，所以七八位为19或者20
  十一位和十二位是月份，这两位是01-12之间的数值
  十三位和十四位是日期，是从01-31之间的数值
  十五，十六，十七都是数字0-9
  十八位可能是数字0-9，也可能是X
  */
  let idcard_patter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/

  // 判断格式是否正确
  let format = idcard_patter.test(idcode)

  // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
  return last === last_no && format
}
/**
 * 生成UUID.
 * @param symbol
 */
export const UUID = (symbol) => {
  let s = []
  let hexDigits = '0123456789abcdef'
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4'
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
  s[8] = s[13] = s[18] = s[23] = (symbol || '')

  let uuid = s.join('')
  return uuid
}



// WEBPACK FOOTER //
// ./src/libs/util.js